// eslint-disable-next-line import/no-cycle
import {

    // User Management
    SETTING_LOAD_PERMISSION,
    SETTING_LOAD_PERMISSION_SUCCESS,
    SETTING_CREATE_PERMISSION,
    SETTING_UPDATE_PERMISSION,
    SETTING_DELETE_PERMISSION,

    SETTING_LOAD_USER,
    SETTING_LOAD_USER_SUCCESS,
    SETTING_CREATE_USER,
    SETTING_UPDATE_USER,
    SETTING_DELETE_USER,

    SETTING_CREATE_USER_PASS,
    SETTING_RESET_USER_PASS

    // END User Management

} from '../../actions';

// // -------------------- User Management --------------------- //
export const getPermission = (data, token) => ({
    type: SETTING_LOAD_PERMISSION,
    payload: data,
    token
});
export const getPermissionSuccess = (data, list) => ({
    type: SETTING_LOAD_PERMISSION_SUCCESS,
    payload: data,
    payloadlist: list
});
export const addPermission = (data, token) => ({
    type: SETTING_CREATE_PERMISSION,
    payload: data,
    token
});
export const updatePermission = (data, token) => ({
    type: SETTING_UPDATE_PERMISSION,
    payload: data,
    token
});
export const deletePermission = (data, token) => ({
    type: SETTING_DELETE_PERMISSION,
    payload: data,
    token
});
//
export const getUser = (data, token) => ({
    type: SETTING_LOAD_USER,
    payload: data,
    token
});
export const getUserSuccess = (data, list) => ({
    type: SETTING_LOAD_USER_SUCCESS,
    payload: data,
    payloadlist: list
});
export const createUser = (data, token) => ({
    type: SETTING_CREATE_USER,
    payload: data,
    token
});
export const updateUser = (data, token) => ({
    type: SETTING_UPDATE_USER,
    payload: data,
    token
});
export const deleteUser = (data, token) => ({
    type: SETTING_DELETE_USER,
    payload: data,
    token
});
//
export const createUserPassword = (data, token) => ({
    type: SETTING_CREATE_USER_PASS,
    payload: data,
    token
});
export const resetPassword = (data, token) => ({
    type: SETTING_RESET_USER_PASS,
    payload: data,
    token
});

// // -------------------- END User Management --------------------- //